module.exports = __webpack_public_path__ + "img/htmlYes.84caabac.svg";